<div class="task-details-tab">
  <!-- Task Information Section -->
  <div class="details-section">
    <h4 class="section-title">Task Information</h4>
    <div class="info-grid">
      <!-- Status -->
      <div class="info-item">
        <label class="info-label">Status</label>
        <div class="info-value">
          <app-status-pill
            variant="solid"
            [color]="getStatusColor()"
            [label]="getStatusName() | titlecase"
            [locked]="getStatusLocked()"
            [truncateAt]="30">
          </app-status-pill>
        </div>
      </div>

      <!-- Priority -->
      <div class="info-item">
        <label class="info-label">Priority</label>
        <div class="info-value">
          <span class="priority-badge" [ngClass]="getPriorityClass()">
            <mat-icon class="badge-icon">flag</mat-icon>
            {{ priority | titlecase }}
          </span>
        </div>
      </div>

      <!-- Deadline -->
      <div class="info-item">
        <label class="info-label">Deadline</label>
        <div class="info-value">
          <mat-icon class="value-icon">calendar_today</mat-icon>
          <span class="value-text">{{ formatDate(dueDate) }}</span>
        </div>
      </div>

      <!-- Stage -->
      <div class="info-item">
        <label class="info-label">Stage</label>
        <div class="info-value">
          <mat-icon class="value-icon">layers</mat-icon>
          <span class="value-text">{{ stage || 'Not set' }}</span>
        </div>
      </div>

      <!-- Flag Reason / Unflag Reason: only present when a reason was added (the parent passes one at a
           time, matching the task's current flagged state). Shown as text; on the Edit page a pencil next to the
           label swaps the text for an editable box with Cancel / Save. View page: read-only text, no pencil. -->
      @if (shownReason) {
        <div class="info-item info-item--full">
          <div class="reason-head">
            <label class="info-label">{{ reasonLabel }}</label>
            @if (canEditFlagReason && !editingReason) {
              <button
                type="button"
                class="reason-edit-button"
                (click)="startEditReason()"
                [attr.aria-label]="'Edit ' + reasonLabel.toLowerCase()"
                matTooltip="Edit reason">
                <mat-icon>edit</mat-icon>
              </button>
            }
          </div>
          @if (!editingReason) {
            <div class="info-value">
              <mat-icon class="value-icon">{{ flagReason ? 'flag' : 'outlined_flag' }}</mat-icon>
              <span class="value-text">{{ shownReason }}</span>
            </div>
          } @else {
            <div class="reason-editor">
              <textarea class="reason-editor__input" rows="3" maxlength="1000" [(ngModel)]="reasonDraft"></textarea>
              <div class="reason-editor__actions">
                <button type="button" class="reason-editor__cancel" (click)="cancelEditReason()">Cancel</button>
                <button type="button" class="reason-editor__save" [disabled]="!canSaveReason" (click)="saveEditReason()">Save</button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Related Items Section -->
  <!-- <div class="details-section">
  <h4 class="section-title">Related Items</h4>


  <div *ngIf="!selectedMilestone" class="milestone-empty-state">
    <mat-icon class="empty-state-icon">flag</mat-icon>
    <p class="empty-state-title">No milestone attached</p>
    <p class="empty-state-subtitle">Connect this task to a project milestone</p>
    <button class="attach-milestone-btn" (click)="onAttachMilestone()">
      <mat-icon class="btn-icon">add</mat-icon>
      Attach to Milestone
    </button>
  </div>


  <div *ngIf="selectedMilestone" class="milestone-card">
    <div class="milestone-header">
      <mat-icon class="milestone-header-icon">flag</mat-icon>
      <h5 class="milestone-header-title">Attached Milestone</h5>
    </div>
    <div class="milestone-body">
      <div class="milestone-info">
        <div class="milestone-status-indicator" [ngClass]="getMilestoneStatusClass()"></div>
        <span class="milestone-name">{{ selectedMilestone.name }}</span>
        <span class="milestone-status-badge">{{ selectedMilestone.status | titlecase }}</span>
      </div>


      <div class="milestone-date-range">
        <mat-icon class="date-icon">calendar_today</mat-icon>
        <span *ngIf="selectedMilestone.startDate && selectedMilestone.endDate">
          {{ selectedMilestone.startDate | date: 'MMM d' }} - {{ selectedMilestone.endDate | date: 'MMM d, yyyy' }}
        </span>
        <span *ngIf="!selectedMilestone.startDate || !selectedMilestone.endDate">
          Due: {{ selectedMilestone.dueDate | date: 'mediumDate' }}
        </span>
        <span class="days-remaining" *ngIf="selectedMilestone.daysRemaining && selectedMilestone.status !== 'completed' && selectedMilestone.status !== 'overdue'">
          • {{ selectedMilestone.daysRemaining }}d left
        </span>
      </div>


      <div class="milestone-progress-section" *ngIf="selectedMilestone.status === 'in-progress' && selectedMilestone.progress !== undefined">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="selectedMilestone.progress"></div>
        </div>
        <span class="progress-text">{{ selectedMilestone.progress }}%</span>
      </div>


      <div class="milestone-task-stats" *ngIf="selectedMilestone.taskStats">
        <mat-icon class="task-icon">check_circle_outline</mat-icon>
        <span>{{ selectedMilestone.taskStats.completed }}/{{ selectedMilestone.taskStats.total }} tasks</span>
      </div>


      <div class="milestone-assigned-to" *ngIf="selectedMilestone.assignedTo">
        <mat-icon class="assigned-icon">person</mat-icon>
        <span>Assigned to: {{ selectedMilestone.assignedTo }}</span>
      </div>

      <p *ngIf="selectedMilestone.description" class="milestone-description">
        {{ selectedMilestone.description }}
      </p>

      <div class="milestone-actions">
        <button class="milestone-action-btn detach-btn" (click)="onDetachMilestone()">
          <mat-icon class="action-icon">close</mat-icon>
          Detach
        </button>
        <button class="milestone-action-btn view-btn" (click)="onViewMilestone()">
          <mat-icon class="action-icon">visibility</mat-icon>
          View Details
        </button>
      </div>
    </div>
  </div>
</div> -->

<!-- Custom Fields Section// Reserved for v4->
<!--
<div class="details-section">
  <h4 class="section-title">Custom Fields</h4>
  <div class="custom-fields-grid">
    -->
    <!-- Estimated Hours -->
    <!--
    <div class="custom-field-item">
      <label class="custom-field-label">Estimated Hours</label>
      <input
        type="number"
        class="custom-field-input"
        placeholder="Enter hours"
        [value]="estimatedHours"
        (input)="onEstimatedHoursChange($event)"
        />
    </div>
    -->
    <!-- Task Stage -->
    <!--
    <div class="custom-field-item">
      <label class="custom-field-label">Task Stage</label>
      <select
        class="custom-field-select"
        [value]="taskStage"
        (change)="onTaskStageChange($event)"
        >
        <option value="">Select stage</option>
        <option value="planning">Planning</option>
        <option value="development">Development</option>
        <option value="review">Review</option>
        <option value="testing">Testing</option>
        <option value="deployment">Deployment</option>
      </select>
    </div>

  </div>
</div>
-->
</div>
